
import { useState } from "react";
import styles from "./animationChapterSbgame.module.css";
import Lottie from "lottie-react";
import maskAnimation from "./maskforthridscreen.json";
import { useTranslation } from "react-i18next";


const ctxEmotion = require.context("../../assets/images/emotion", false, /\.(png|jpe?g|webp)$/);
const ctxExpert  = require.context("../../assets/images/expert",  false, /\.(png|jpe?g|webp)$/);
const ctxDots    = require.context("../../assets/images/theDots", false, /\.(png|jpe?g|webp)$/);

const ctxByFolder = {
  emotion: (n) => ctxEmotion(`./${n}.png`),
  expert:  (n) => ctxExpert(`./${n}.png`),
  theDots: (n) => ctxDots(`./${n}.png`)
};

const AnimationChapterSbgame = ({ setIsAnimating, variables, setVariables }) => {
  const { t } = useTranslation();

  const key = variables?.introductionScreen || "Stirring_Emotions";
  const cfg = t(`animationsTeen.${key}`, { returnObjects: true }) || t(`animationsTeen.Stirring_Emotions`, { returnObjects: true });
  const subs = t(`animationsTeen.${key}.content`, { returnObjects: true });

 
  const themeClass =
    key === "Connecting_Dots" ? styles.themeDots
    : key === "Trust_Expert"  ? styles.themeExpert
    : /* default */             styles.themeEmotion;

  const [visibleCount, setVisibleCount] = useState(0);
  const [flash, setFlash] = useState(false);



  const endAnimation = () => {
    setIsAnimating(false);
    setVariables((prev) => {
      const { introductionScreen: _omit, ...rest } = prev || {};
      return rest;
    });
  };

  const handleClick = () => {
    if (visibleCount < cfg.layerCount - 1) {
      setFlash(true);
      setTimeout(() => setFlash(false), 200);
      setVisibleCount((v) => v + 1);
    } else {
      endAnimation();
    }
  };

  const asset = (n) => ctxByFolder[cfg.folder](n);

  return (
    <div className={`${styles.wrapperAnimation} ${themeClass}`}>
      <div className={styles.imageWrapper}>
        <div className={styles.textSection}>
          {/* Colors for title/subtitle are applied via CSS variables in the theme class */}
          <h1 className={styles.title}>{cfg.title}</h1>
          <p className={styles.subtitle}>{subs[visibleCount] || ""}</p>
        </div>

        <div
          className={`${styles.imageContainer} ${flash ? styles.clickFlash : ""}`}
          onClick={handleClick}
        >
          {/* base layer */}
          <img src={asset(1)} alt="Base Layer" className={`${styles.image} ${styles.visible}`} />

          {/* layers 2..N; special Lottie on layer 3 for Connecting_Dots */}
          {Array.from({ length: cfg.layerCount - 1 }, (_, i) => i + 2).map((index) => {
            const isVisible = visibleCount >= index - 1;
            if (key === "Connecting_Dots" && index === 3) {
              return isVisible ? (
                <div key={index} className={`${styles.lottieWrapper} ${styles.visible}`}>
                  <Lottie animationData={maskAnimation} loop={false} style={{ width: "100%", height: "100%" }} />
                </div>
              ) : null;
            }
            return (
              <img
                key={index}
                src={asset(index)}
                alt={`Layer ${index}`}
                className={`${styles.image} ${isVisible ? styles.visible : ""}`}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AnimationChapterSbgame;

